<template>
<section>
  <social-header v-if="currentEnv" title="认证升级"></social-header>
  <!--表单-->
	<div class="identification">
		<p class="identification-tips">成为亲友团认证用户可额外获得奖励哦~</p>
		<div class="identification-type">
			<div class="identification-type-col">
				<p><img src="https://dealer2.autoimg.cn/dealerdfs/g26/M06/D2/9E/autohomedealer__ChcCP1tFdrKATVQ0AAANWwp3GdM262.png" alt=""></p>
				<router-link :to="{path:'/certificate/owner'}" v-stat:click="{name:'owner'}">
					<h3>车主认证</h3>
					<p>完成车主认证，获得专属身份标识</p>		
				<em class="iconfont_M icon-more_M"></em>
      </router-link>
			</div>
			<div class="identification-type-col">
				<p><img src="https://dealer2.autoimg.cn/dealerdfs/g26/M07/D0/B7/autohomedealer__wKgHEVtFdr-AIr4oAAANg93TbXM452.png" alt=""></p>
				<router-link :to="{path:'/certificate/insure'}" v-stat:click="{name:'insure'}">
					<h3>保险代理人认证</h3>
					<p>完成代理人认证，获得专属奖励</p>
				<em class="iconfont_M icon-more_M"></em>
		   </router-link>
		 </div>
    </div>
	</div>
	<!--表单1-->
  </section>
</template>

<script>
  import SocialHeader from '../../components/social-header.vue'
  import { isWeiXin, isDingDing, changeDocumentTitle } from '../../service/environment'

  export default {
    components: {
      SocialHeader
    },
    name: 'CertificateHome',
    data: function () {
      return {
      }
    },
    created () {
      changeDocumentTitle('认证升级')
    },
    computed: {
      currentEnv () {
        if (isWeiXin()) {
          return false
        } else if (isDingDing()) {
          return false
        } else {
          return true
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/certificate/home.vue